import { isDev } from '@app/data';
import { LoggerTypes } from '@app/enums';
import { LogTypeKeys } from '@app/interfaces';
import { loggerProps } from '@app/types';

/**
 * Log both on console and analytics tool.
 *
 * Options:
 *
 * - ForceConsole - to force logging to console even on production. Useful for
 *   blocking errors.
 *
 * @type {{
 *   error: function;
 *   info: function;
 *   log: function;
 *   warn: function;
 * }}
 */

export const logger = Object.values(LoggerTypes).reduce(
  (
    obj: {
      [key: string]: (message: string | object, object?: loggerProps) => void;
    },
    type
  ) => {
    obj[type] = (
      message,
      { forceConsole = false }: loggerProps | undefined = {}
    ) => {
      if (isDev || forceConsole) {
        // eslint-disable-next-line no-console
        console[type as keyof LogTypeKeys]?.(message);
      }
    };
    return obj;
  },
  {}
);

export const Metric = {
  FormStart: 'Form Start',
  FormComplete: 'Form Complete',
};

/** Log metric for performance monitoring */
export const logMetric = (message: string) => logger.log(`[Metric] ${message}`);
